module.exports = __webpack_public_path__ + "img/dialog.2a8d5904.png";